<template>
    <div>
        <div class="pos kzgmain">
            <b> 您的位置：</b>
            <a href="/" title="首页"> 首页 </a>
            <i v-show="titles">
                <span> &gt; </span>
                <a href="javascript:;" :title="titles">{{ titles }}</a>
            </i>
            <i>
                <span> &gt; </span>
                <a> {{ name }}</a>
            </i>
        </div>
        <!-- 控制柜分类 -->
        <div class="pos_bor kzgmain" v-if="this.title != '行业案例'">
            <div class="side">
                <div class="side_tit">
                    <h2>恒智自控<br>control cabinet</h2>
                </div>
                <div class="side_type">
                    <!--  -->
                    <el-menu v-if="cptitle == '产品中心'" default-active="number" class="el-menu-vertical-demo">
                        <el-submenu v-bind:class="name == menu.name ? 'hov' : ''" :index="menu.name"
                            v-for="(menu, index) in cptypeList" :key="index" @click="onEnterTd(index)">
                            <template slot="title">
                                <span slot="title">{{ menu.name }}</span>
                            </template>
                            <router-link :to="{ path: '/HzProduct', query: { id: item.id, name: item.name } }"
                                v-for="(item, i) in menu.children" :key="i">
                                <el-menu-item :index="item.name">
                                    <span slot="title">{{ item.name }}</span>
                                </el-menu-item>
                            </router-link>
                        </el-submenu>
                    </el-menu>
                    <!-- 控制柜 -->
                    <div v-else-if="name != '产品中心'" v-bind:class="name == item.name ? 'hov' : ''"
                        v-for="(item, index) in cptypeList" :key="index">
                        <h3>
                            <router-link class="side_bor" :title="item.name"
                                :to="{ path: '/HzControl', query: { id: item.id, name: item.name } }">
                                {{ item.name }}
                            </router-link>
                        </h3>
                    </div>
                </div>
                <div class="side_tit" style="margin-top: 10px;">
                    <h2>
                        在线联系：<br>
                        0531-83176606
                    </h2>
                </div>
            </div>
            <div class="tab" v-for="info in this.infoList">
                <h2 class="t_name"><span>{{ name }}</span></h2>
                <div class="tab_items">
                    <div class="banner1">
                        <div class="data_path">
                            <div class="item">
                                <img :src="fileList[currentIndex]">
                            </div>
                            <div class="page" v-if="fileList.length > 1">
                                <ul>
                                    <!--  @click="gotoPage(prevIndex)"  @click="gotoPage(nextIndex)" -->
                                    <li>&lt;</li>
                                    <li v-for="(item, index) in fileList" @click="gotoPage(index)"
                                        v-bind:class="currentIndex == index ? 'current' : ''"> {{ index + 1 }}</li>
                                    <li>&gt;</li>
                                </ul>
                            </div>
                        </div>
                        <div class="brief_info">
                            <h4>{{ info.ciTitle }}</h4>
                            <div class="wow fadeInRight1 animate__animated">
                                <span>{{ info.ciOverview }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="pro_wait clearfix">
                        <div class="pd_hotline">
                            <img class="img" src="../../images/tel.png"> <span>咨询热线</span>
                            <span class="font_hotline">0531-55511916</span>
                        </div>
                    </div>
                    <div class="detail_content">
                        <h2 class="title wow fadeInDown2 animate__animated">
                            <strong>产品简介</strong>
                            <img src="../../images/line.png">
                        </h2>
                        <div class="pro_detail">
                            <h3 v-html="info.ciBrief"></h3>
                        </div>

                        <h2 class="title wow fadeInDown2 animate__animated">
                            <strong>产品特点</strong>
                            <img src="../../images/line.png">
                        </h2>
                        <div class="pro_detail">
                            <h3 v-html="info.ciChara"></h3>
                        </div>

                        <h2 class="title wow fadeInDown2 animate__animated">
                            <strong>产品展示图</strong>
                            <img src="../../images/line.png">
                        </h2>
                        <div class="detail_pic" v-for="(item, index) in fileList" :key="index">
                            <img :src="item">
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- 行业案例 -->
        <div class="al_bor almain" v-else-if="title == '行业案例'">
            <div class="side alInfo_side">
                <div class="side_tit">
                    <h2>恒智自控<br>industry cases</h2>
                </div>
                <div class="side_type">
                    <div v-bind:class="name == item.codeDesc ? 'hov' : ''" v-for="(item, index) in caseTList" :key="index"
                        @click="onEnterTd(index)">
                        <h3>
                            <router-link class="side_bor"
                                :to="{ path: '/HzHyal', query: { id: item.cdCode, name: item.codeDesc } }">
                                {{ item.codeDesc }}
                            </router-link>
                        </h3>
                    </div>
                </div>
                <div class="side_tit" style="margin-top: 10px;">
                    <h2>
                        在线联系：<br>
                        <!-- <img src="../../images/phone12.png" style="width: 35px;height: 35px;"> -->
                        0531-83176606
                    </h2>
                </div>
            </div>
            <div class="alInfo" v-for="item in this.aiInfoList">
                <h1>{{ item.aiTitle }}</h1>
                <div class="al_info">
                    <span>来源：{{ item.aiSource }}</span>
                    <span>浏览：{{ item.aiBrowse }}</span>
                    <span>发布日期：{{ item.aiIssueDt }}</span>
                </div>
                <div class="al_body" v-html="item.aiContent"></div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '../../js/axios'
import router from '../../router'

export default {
    name: 'HzDetails',
    components: {
        router
    },
    data() {
        return {
            id: this.$route.query.id,
            name: this.$route.query.name,
            title: this.$route.query.title,
            cptitle: this.$route.query.cptitle,
            aiBrowse: '',
            image: '',
            titles: '',
            cptypeList: [],
            fileList: [],
            currentIndex: 0,   //默认显示图片
            timer: null,    //定时器
            infoList: [],
            briefInfo: '',
            aiInfoList: [], //行业案例
            caseTList: [],
        };
    },
    computed: {},
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.path = this.$route.fullPath
                // console.log(this.$route)
            }
        }
    },
    methods: {
        changeNum() {
            // console.log(this.aiBrowse);
            http.get('/hzAlInfo/upBrowse', { params: { aiId: this.id, aiBrowse: this.aiBrowse } }).then(res => {

            })
        },
        queryAlType() {
            http.get('/hzAlInfo/aiType', { params: { aiId: this.id } }).then((res) => {
                this.aiInfoList = res.data.data.result;
                console.log(this.aiInfoList);
                this.caseTList = res.data.data.aiType;
                console.log(this.caseTList);
                this.aiInfoList.forEach(item => {
                    item.aiCoverPath = this.image + item.aiCoverPath;
                    this.aiBrowse = item.aiBrowse;
                })
                this.changeNum();
            })
        },
        queryCpMenu() {
            let menuT = '';
            if (this.name === '产品中心') {
                menuT = 'P';
            } else {
                menuT = 'K'
            }
            http.get('/hzCpTree/cpTree', { params: { menuT: menuT } }).then((res) => {
                if (this.name === '产品中心') {
                    this.cptypeList = res.data.data.result[0].children;
                } else {
                    this.cptypeList = res.data.data.result;
                }
            })
        },
        queryCpInfo() {
            let cmType = this.name;
            if (this.name === '产品中心') {
                cmType = '';
            }
            // let cmId = this.id;
            http.get('/hzCpInfo/cpInfo', { params: { cmType: cmType, ciId: this.id } }).then((res) => {
                this.infoList = res.data.data.result;
                this.infoList.forEach(item => {
                    item.ciCoverPath = this.image + item.ciCoverPath;
                    this.fileList.push(item.ciCoverPath);
                })
                res.data.data.fileList.forEach(file => {
                    file = this.image + file;
                    this.fileList.push(file);
                })
            })
        },
        gotoPage(index) {
            this.currentIndex = index;
        },
        //上一张
        prevIndex() {
            if (this.currentIndex == 0) {
                return this.fileList.length - 1;
            } else {
                return this.currentIndex - 1;
            }
        },
        //下一张
        nextIndex() {
            if (this.currentIndex == this.fileList.length - 1) {
                return 0;
            } else {
                return this.currentIndex + 1;
            }
        }
    },
    created() {
        this.image = http.imageURL
        this.cptypeList = JSON.parse(window.localStorage.getItem('kzgType'));
        this.titles = window.localStorage.getItem('titles')
        if(this.cptitle === '产品中心'){
            this.cptypeList = JSON.parse(window.localStorage.getItem('cpType'));
        }
        // console.log(this.cptypeList);
        if (this.title === '行业案例') {
            this.queryAlType();
        } else {
            // this.queryCpMenu();
            this.queryCpInfo();
        }
    },
    mounted() {
    }
}
</script>

<style>
@import "../../config/Control.css"
</style>


// WEBPACK FOOTER //
// src/views/details/HzDetails.vue